import React from 'react'
import { connect } from 'react-redux'
import { GlobalState } from 'reducers'
import styles from './index.module.sass'

interface Props {
  onChange: () => void,
}

const UserCameraControls: React.FC<Props> = ({onChange}) => {
  return (
    <div className={styles.root} data-type='hoverIssue'>
      <div className={styles.button} onClick={onChange} data-type='hoverIssue'> go to default pos </div>
    </div>
  )
}

export default connect(
  (state: GlobalState) => ({
  }),
  dispatch => ({
    onChange() {
      dispatch({type: 'changeCamPos'})
    }
  })
)(UserCameraControls)
